export const clientShopId =
  window.CLIENT_SHOP_ID || process.env.REACT_APP_CLIENT_SHOP_ID;
export const lineOAUrl =
  window.LINE_AT_URL || process.env.REACT_APP_LINE_URL || '';
export const shop = window.SHOP || {};
export const baseRoute =
  window.BASE_ROUTE || process.env.REACT_APP_BASE_ROUTE || '';
export const clientLiffId =
  window.CLIENT_LIFF_ID || process.env.REACT_APP_CLIENT_LIFF_ID;
export const apiHost =
  window.API_FORMICA_HOST ||
  process.env.REACT_APP_API_HOST ||
  window.location.origin;
export const tpApiHost =
  window.API_HOST ||
  process.env.REACT_APP_API_TP_HOST ||
  window.location.origin;

export const GA_trackId =
  window.TRACKING_ID || process.env.REACT_APP_TRACKING_ID || '';
export const GaMeasurementId =
  window.MEASUREMENT_ID || process.env.REACT_APP_MEASUREMENT_ID || '';
export const stage = process.env.REACT_APP_ENV || '';
export const passcode = process.env.REACT_APP_PASSCODE || '';

console.log(stage);

export const ANNOTATION_DATE_MODES = {
  DATETIME: 'DATETIME',
  TIME: 'TIME',
  DATE: 'DATE',
  LUNAR: 'LUNAR',
};

export const ORDER_FORM_TYPES = {
  STRING: 'STRING',
  DATE: 'DATE',
  ARRAY: 'ARRAY',
  OPTIONS: 'OPTIONS',
  CUSTOM: 'CUSTOM',
};

export const DATE_FORAMT = {
  DATETIME: 'YYYY/MM/DD HH:mm',
  TIME: 'HH:mm',
  DATE: 'YYYY/MM/DD',
  LUNAR: 'YYYY/MM/DD',
};

export const VARIABLES = {
  PAYMENT: [
    { key: 'ATM', value: 'ATM' },
    { key: 'FACE', value: '面交付款' },
    { key: 'CASH', value: '貨到付款' },
    { key: 'CREDIT', value: '信用卡(一次付清)' },
    { key: 'CREDIT_INSTALLMENT', value: '信用卡(分期付款)' },
    { key: 'LINEPAY', value: 'LINE PAY' },
    { key: 'CUSTOM', value: '自訂' },
  ],
  DELIVERY: [
    { key: 'FACE', value: '寄送' },
    { key: 'SEVEN', value: '7-Eleven' },
    { key: 'FAMILY', value: '全家' },
    { key: 'HOME', value: '宅配' },
    { key: 'STORE', value: '門市自取' },
    { key: 'NONE', value: '無' },
    { key: 'CUSTOM', value: '寄送' },
  ],
  PAYMENT_STATUS: [
    { key: 'UNPAID', value: '未付款' },
    { key: 'PAID', value: '已付款' },
    { key: 'REFUNDING', value: '退款中' },
    { key: 'REFUNDED', value: '已退款' },
    { key: 'EXPIRED', value: '已過期' },
    { key: 'ERROR', value: '錯誤' },
  ],
  LOGISTIC_STATUS: [
    { key: 'PACKING', value: '尚未出貨' },
    { key: 'SHIPPING', value: '發貨中' },
    { key: 'SHIPPED', value: '已發貨' },
    { key: 'ARRIVED', value: '已送達' },
    { key: 'RETURNING', value: '派車退件' },
    { key: 'RETURNED', value: '已退回' },
  ],
};
export const ANNOTATION_TYPES = {
  NUMBER: 'NUMBER',
  INPUT: 'INPUT',
  ITEM_LIST: 'ITEM_LIST',
  CHECKBOX: 'CHECKBOX',
  DATE: 'DATE',
  OPTIONS: 'OPTIONS',
  ORDERER: 'ORDERER',
  BRANCH: 'BRANCH',
  STORE_SEVEN: 'STORE_SEVEN',
  STORE_FAMILY: 'STORE_FAMILY',
  COUPON: 'COUPON',
  POINT: 'POINT',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
};
export const ANNOTATION_SYSYEM_KEYS = {
  PAYMENT: 'payment',
  DELIVERY: 'delivery',
  COUPON: 'coupon',
  POINT: 'point',
  ACCOUNT: 'account',
  INSTALLMENT_MONTH: 'installment_month',
  BRANCH: 'branch',
  ADDRESS: 'address',
  STORE_FAMILY: 'store_family',
  STORE_SEVEN: 'store_seven',
};
export const ANNOTATION_DELIVERY_KEYS = {
  STORE: 'branch',
  FAMILY: 'store_family',
  SEVEN: 'store_seven',
};

export const CLIENT_TYPES = { AGENT: 'AGENT', CLIENT: 'CLIENT' };

export const DEFAULT_APP_BAR_HEIGHT = 62;
export const DEFAULT_APP_TITLE_HEIGHT = 50;

export const STATUS = {
  ON: 'ON',
  OFF: 'OFF',
  HOT: 'HOT',
};

export const TAG_TYPES = {
  PRODUCT: 'PRODUCT',
  CUSTOMER: 'CUSTOMER',
  CATEGORY: 'CATEGORY',
};

// export const PRODUCT_MATERIAL_TEXT = "材質";
// export const PRODUCT_MATERIAL_SPEC_TEXT = "spec";

export const verifyState = {
  UNVERIFY: 'UNVERIFY',
  VERIFYING: 'VERIFYING',
  VERIFIED: 'VERIFIED',
};

export const FORM_TYPES = {
  ORDER_FORM: 'ORDER_FORM',
  CONFIRM_ORDER: 'CONFIRM_ORDER',
  ORDER_SUCCESS: 'ORDER_SUCCESS',
};

export const ORDER_STEPS_ID = {
  ORDER_FORM: 'cart_title',
  CONFIRM_ORDER: 'order_form_title',
  ORDER_SUCCESS: 'confirm_title',
};

export const MAX_SORT_INDEX = 99999;
export const DEFAULT_TOOLBAR_HEIGHT = 40;
export const MAX_QUANTITY = 2;
export const MAX_CARTS_QUANTITY = 10;
export const HIDE_ORDER = false; // stage === 'production';
